import { render, staticRenderFns } from "./PreviewImageSwiper.vue?vue&type=template&id=adb25eb0&scoped=true"
import script from "./PreviewImageSwiper.vue?vue&type=script&lang=js"
export * from "./PreviewImageSwiper.vue?vue&type=script&lang=js"
import style0 from "./PreviewImageSwiper.vue?vue&type=style&index=0&id=adb25eb0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb25eb0",
  null
  
)

export default component.exports